export default __webpack_public_path__ + "120b4c7bbd155bd0a04dc37d334baced.ttf";